export default __webpack_public_path__ + "static/media/IMG_1715.57f449b2.jpg";